import { gql } from '@apollo/client';
import { CLAIM_ITEM_FIELDS } from './claim_items';
import { CLAIM_ADJUSTMENT_FIELDS } from './claim_adjustments';

export const CLAIM_FIELDS = gql`
    ${CLAIM_ITEM_FIELDS}
    ${CLAIM_ADJUSTMENT_FIELDS}
    fragment ClaimFields on claims {
        carrier_id
        claim_id
        claim_number
        claim_status
        claim_type
        completed_at
        completed_by
        created_at
        created_by
        freight_amount
        incident_date
        investigating_at
        last_modified_at
        middle_mile_carrier_id
        onward_responsible
        order_id
        rejected_at
        rejection_reason
        reopened_at
        reopened_by
        requested_by
        shipper_id
        supporting_documents
        items {
            ...ClaimItemFields
        }
        adjustments {
            ...ClaimAdjustmentFields
        }
    }
`;
